import type { RefObject, FC } from 'react';
import { createRef, PureComponent } from 'react';
import track from 'react-tracking';
import { withTheme } from 'styled-components';
import type { WithThemeProps } from '@simplywallst/ui-core';
import { Button } from '@simplywallst/ui-core';
import type { InsiderTransation } from '@/pages/CompanyReport/components/InsiderTradingTransactions/redux/selectors';
import { Cards } from '@/pages/CompanyReport/components/InsiderTradingTransactions';
import { DeprecatedTruncator } from '@components/Truncator';
import { InsiderTradingAccordionWrapper, CardWrapper } from './styled';

export interface InsiderTradingAccordionProps {
  data: InsiderTransation[];
}

interface State {
  open: boolean;
  active: number[];
  tracked: boolean;
}

/** TODO: refactor to function component */
class InsiderTradingAccordion extends PureComponent<
  InsiderTradingAccordionProps & Tracking & WithThemeProps,
  State
> {
  private ref: RefObject<HTMLDivElement>;

  constructor(props) {
    super(props);
    this.ref = createRef<HTMLDivElement>();
    this.state = {
      open: false,
      active: [],
      tracked: false,
    };
  }

  handleClick = (index: number) => {
    this.setState(({ active }) => ({
      active: active.includes(index)
        ? active.filter((n) => n !== index)
        : [...active, index],
      open: true,
      tracked: true,
    }));
  };

  handleShowMore = () => {
    const {
      ref: { current },
    } = this;
    const {
      theme,
      tracking: { trackEvent },
    } = this.props;
    const { open, tracked } = this.state;

    if (!tracked) {
      trackEvent({
        action: 'click',
        modifier: 'show_more',
      });
    }

    if (open && current) {
      window.scroll({
        left: 0,
        top:
          current.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          theme.x15spacePx -
          theme.x8spacePx,
      });
    }

    this.setState(({ open, active }) => ({
      open: !open,
      tracked: true,
      active: !open === false ? [] : active,
    }));
  };

  render() {
    const { ref, handleClick, handleShowMore } = this;
    const { open, active } = this.state;
    const { data } = this.props;

    return (
      <InsiderTradingAccordionWrapper
        data-cy-id="insider-trading-accordion"
        ref={ref}
      >
        {data.length > 5 ? (
          <>
            <DeprecatedTruncator open={open} minHeight={320}>
              <CardWrapper>
                <Cards data={data} active={active} handleClick={handleClick} />
              </CardWrapper>
            </DeprecatedTruncator>
            <Button
              styleType="gentleLarge"
              display="block"
              onClick={handleShowMore}
            >{`Show ${open ? 'less' : 'more'}`}</Button>
          </>
        ) : (
          <Cards data={data} active={active} handleClick={handleClick} />
        )}
      </InsiderTradingAccordionWrapper>
    );
  }
}

export default track({
  type: 'track',
})(
  withTheme(InsiderTradingAccordion)
) as unknown as FC<InsiderTradingAccordionProps>;
